// Views register an allow-listed snapshot of what they show, so the Bug button can describe the screen without screenshots.
import { createContext, useCallback, useContext, useMemo, useRef, type ReactNode } from "react";

export interface ViewSnapshot {
  view: string;
  ids: Record<string, string>;
  summary: string | { state?: string; status?: string; stage?: string; tab?: string; loading?: boolean; count?: number };
}
interface Api {
  register: (s: ViewSnapshot) => void;
  snapshot: () => ViewSnapshot;
}
const Ctx = createContext<Api | null>(null);

export function ViewStateProvider({ children }: { children: ReactNode }) {
  const ref = useRef<ViewSnapshot>({ view: "unknown", ids: {}, summary: "" });
  const register = useCallback((s: ViewSnapshot) => {
    ref.current = s;
  }, []);
  const snapshot = useCallback(() => ref.current, []);
  const api = useMemo(() => ({ register, snapshot }), [register, snapshot]);
  return <Ctx.Provider value={api}>{children}</Ctx.Provider>;
}

export function useViewState(): Api {
  const v = useContext(Ctx);
  if (!v) throw new Error("useViewState outside ViewStateProvider");
  return v;
}
